import DashboardIcon from "@mui/icons-material/Dashboard";

const menu: any[] = [
  {
    id: 0,
    title: "Dashboard",
    icon: <DashboardIcon />,
    route: "/dashboard",
  },
];

export default menu;
